import React, { useState, useEffect } from "react";
import s from "./VentasTelekino.module.css";

//assets
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Pager from "../../../Shared/Pagination/Pagination";
import exportService from "../../../../api/delivery/exportService";
import { dateFormats } from "../../../../helpers/convertDate";
import { formatJavaCompleto } from "../../../../config/strings";

//materialUi
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import DownloadIcon from "@mui/icons-material/Download";

import UploadModal from "./UploadModal";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "0.9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const VentasTelekino = () => {
  const { t } = useTranslation();
  const { textColor } = useSelector((state) => state.local);

  //Estados
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    raffleId: null,
    date: null,
  });
  const [items, setItems] = useState([]);
  const [openError, setOpenError] = useState(false);

  //Paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  const { formatLocalDate } = dateFormats();
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "processedFile",
  });

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };
  const getFiles = () => {
    setLoading(true);
    exportService
      .getSalesReportsTable(
        page,
        pageSize,
        sort,
        filters.raffleId,
        filters.date,
      )
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        setOpenError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFiles();
  }, [page, pageSize, sort, filters]);

  return (
    <>
      <Grid container className={s.container}>
        <Grid item container xs={11} className={s.header}>
          <Grid item xs={12} lg={5} md={8} className={s.titleContainer}>
            <ShoppingCartCheckoutIcon
              sx={{ fontSize: "2rem", color: "primary.main" }}
            />
            <h4>{t("telekinoSolds")}</h4>
          </Grid>
          <Grid item xs={12} lg={2} md={3}>
            <Tooltip placement="top" title={t("downloadFile")}>
              <Button
                variant="contained"
                className={s.uploadBtn}
                onClick={() => setOpen(true)}
              >
                <DownloadIcon sx={{ fontSize: "2rem" }} />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>

        {loading ? (
          <Grid item xs={11} className={s.loader}>
            <CircularProgress size={"4rem"} />
          </Grid>
        ) : items?.length ? (
          <Grid item container xs={11} className={s.data}>
            <TableContainer className={s.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        ...cellStyles,
                        fontWeight: 500,
                        backgroundColor: "primary.main",
                        color: textColor,
                      }}
                      onClick={() => handleSort("processedDate")}
                    >{`${t("processDate")} ${sort.field === "processedDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                    <TableCell
                      sx={{
                        ...cellStyles,
                        fontWeight: 500,
                        backgroundColor: "primary.main",
                        color: textColor,
                      }}
                      onClick={() => handleSort("processedFile")}
                    >{`${t("archive")} ${sort.field === "processedFile" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                    <TableCell
                      sx={{
                        ...cellStyles,
                        fontWeight: 500,
                        backgroundColor: "primary.main",
                        color: textColor,
                      }}
                      onClick={() => handleSort("raffleId")}
                    >{`${t("drawNumber")} ${sort.field === "raffleId" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, i) => {
                    return (
                      <React.Fragment>
                        <TableRow
                          key={item.id}
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {formatLocalDate(
                              item.processDate,
                              formatJavaCompleto,
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.processedFile || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.raffle.number || "-"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: "50px",
              }}
            >
              <Pager
                pageSize={pageSize}
                setPageSize={setPageSize}
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                pageCustom={pageCustom}
                setPageCustom={setPageCustom}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} className={s.noResults}>
            {t("noResults")}
          </Grid>
        )}
        <UploadModal open={open} setOpen={setOpen} />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VentasTelekino;
